module.exports = __webpack_public_path__ + "static/media/09-09.5a0e00cf.png";